/* src/app/shared/strava-stats/strava-stats.component.scss */
.gridContainer {
  display: grid;
  grid-template-columns: auto auto;
  width: 90vw;
}
.gridItem {
  text-align: center;
  text-shadow: 0 0 2px gray;
}
h4 {
  font-size: small;
  margin: 0;
  margin-top: 5vw;
  line-height: 1;
}
h2 {
  margin: 0;
  margin-bottom: 5vw;
}
/*# sourceMappingURL=strava-stats.component.css.map */
